/** Create User reducer actions */
export const CREATEUSER_ACTIONS = {
    LOADING : "loading",
    ERROR: "error",
}